var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apply"},[_c('div',{staticClass:"title",class:_vm.$vuetify.theme.dark ? '': 'sub-title-l'},[_vm._v(_vm._s(_vm.$t('preference.cause.title')))]),_c('div',{staticStyle:{"flex":"1"},attrs:{"id":"cause"}})])}
var staticRenderFns = []

export { render, staticRenderFns }